/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        $(".wp-block-button.btn a").each(function () {
          $(this).attr("title", $(this).text());
        });
        $("body").attr(
          "style",
          "--height: " + $(".stickyMenu .home__hero__logo").outerHeight() + "px"
        );

        $(".home__hero__logo").attr(
          "style",
          "--toggleHeight:" +
            $(".stickyMenu .stickyMenu__burger").height() +
            "px"
        );

        $('input:not([type="checkbox"]),textarea').each(function () {
          var inputValue = $(this).val();
          "" != inputValue
            ? ($(this).addClass("filled"),
              $(this).parents(".form-group").addClass("focused"))
            : ($(this).removeClass("filled"),
              $(this).parents(".form-group").removeClass("focused"));
        });

        function closeSearch() {
          $(".searchmenu").removeClass("active"),
            $("body").removeClass("megamenu-active"),
            $("#burgerIcon").removeClass("open");
        }

        $(document).on("click", ".close-toggle", function (e) {
          $(".search-field").val("");
          $(".search-form").submit();
          return false;
        }),
          $(document).on("click", "#acceptCookie", function (e) {
            e.preventDefault(),
              setCookie("CookiePolicy", "true", 50),
              $("#cookiePolicy").slideUp();
          }),
          $(document).on("click", ".stickyMenu__search a", function (e) {
            e.preventDefault(),
              $(".searchmenu").toggleClass("active"),
              $("body").toggleClass("search-active");
          }),
          $(document).on("click", "#searchCloseButton", function (e) {
            e.preventDefault(), closeSearch();
          }),
          $(document).on("click", "#searchIcon", function (e) {
            e.preventDefault(), closeSearch();
          }),
          $(document).on("keyup", function (evt) {
            27 == evt.keyCode && closeSearch();
          }),
          jQuery("#searchField").on("keyup", function (e) {
            e.preventDefault(),
              13 == e.keyCode && closeSearch(),
              27 == e.keyCode && closeSearch();
          }),
          $(document).on("click", "#burgerIcon", function (e) {
            e.preventDefault();
            if ($("body").hasClass("megamenu-active")) {
              closeSearch();
            } else {
              $(this).toggleClass("open"),
                $("body").toggleClass("megamenu-active");
            }
          }),
          $(document).on("keypress", "#burgerIcon", function (e) {
            e.preventDefault();

            var key = e.which;
            if (key == 13) {
              // the enter key code
              if ($("body").hasClass("megamenu-active")) {
                closeSearch();
              } else {
                $(this).toggleClass("open"),
                  $("body").toggleClass("megamenu-active");
              }
            }
          }),
          $(".btn, .wp-block-button__link").mousemove(function (e) {
            var x = e.offsetX,
              y = e.offsetY;
            $(this).attr("style", "--x:" + x + "px;--y:" + y + "px;");
          }),
          $(document).on(
            "focus",
            'input:not([type="checkbox"]), textarea',
            function () {
              $(this).parents(".form-group").addClass("focused");
            }
          ),
          $(document).on(
            "blur",
            'input:not([type="checkbox"]), textarea',
            function () {
              "" == $(this).val()
                ? ($(this).removeClass("filled"),
                  $(this).parents(".form-group").removeClass("focused"))
                : $(this).addClass("filled");
            }
          );

        $(".is-style-popup-player video").each(function () {
          var elHeight = $(this).outerHeight(),
            elWidth = $(this).outerWidth(),
            elTop = $(this).offset().top,
            elLeft = $(this).offset().left - window.pageXOffset,
            offsetTop = $(this).offset().top - window.pageYOffset,
            el = $(this);

          $(this)
            .parents(".is-style-popup-player")
            .attr(
              "style",
              "--height: " +
                elHeight +
                "px; --width:" +
                elWidth +
                "px; --top: " +
                elTop +
                "px; --left: " +
                elLeft +
                "px; --offsetTop: " +
                offsetTop +
                "px;"
            );
        });

        $(document).on(
          "click",
          ".is-style-popup-player video:not(.playing)",
          function () {
            var elPoster = $(this).attr("poster"),
              el = $(this);

            $(this).before('<img class="dummy" src="' + elPoster + '"/>');
            $(this).after(
              '<div class="dummy poster"><img src="' + elPoster + '" /></div>'
            );
            $(this).before('<div class="cover"></div>');
            $(el).parents(".is-style-popup-player").addClass("playing");

            $(el).addClass("playing");
          }
        );
        $(document).on(
          "click",
          ".is-style-popup-player video.playing",
          function () {
            var elParent = $(".is-style-popup-player.playing");
            var el = $("video.playing");

            if ($(this).hasClass("triggered")) {
              $(this).removeClass("triggered");
            } else {
              // $(elParent).children(".dummy, .cover").remove();
              // $(el).parents(".is-style-popup-player").removeClass("playing");
              // $(el).removeClass("playing");
            }
          }
        );

        $(document).on("click", ".playing .dummy.poster", function () {
          var el = $("video.playing");
          $(this).remove();
          document.querySelector("video.playing").pause();
        });

        $(document).on("click", ".cover", function () {
          var el = $("video.playing");

          var elParent = $(".is-style-popup-player.playing");

          var el = $("video.playing");

          if ($(el).hasClass("triggered")) {
            $(this).removeClass("triggered");
          } else {
            document.querySelector("video.playing").pause();

            $(elParent).children(".dummy, .cover").remove();
            $(el).parents(".is-style-popup-player").removeClass("playing");
            $(el).removeClass("playing");
          }
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        if ($(".cta-slider > div").length > 1) {
          $(".cta-slider").slick({
            autoplay: true,
            arrows: false,
            dots: true,
            autoplaySpeed: 10000,
            appendDots: $(".new-dots"),
          });
        }
        $(".gform_fields label")
          .not(".gfield_consent_label, .ginput_container_select label")
          .each(function () {
            var label = $(this).html();
            var inputfor = $(this).attr("for");
            $("#" + inputfor + "").after(
              '<label class="gfield_label below dynamic">' + label + "</label>"
            );
          });

        $(".editor-styles-wrapper a")
          .not(".card-link")
          .each(function () {
            var text = $(this).text();
            $(this).attr("title", text);
          });

        $(window).scroll(function () {
          if ($(document).scrollTop() > $("header").height()) {
            $("body").addClass("scrolled");
          } else {
            $("body").removeClass("scrolled");
          }
        });

        function spacerREM() {
          if ($(".wp-block-spacer").length) {
            $(".wp-block-spacer").each(function () {
              var height = $(this).outerHeight();
              var classes = $(this).attr("class");
              console.log(height);
              var converted = height / 16;
              $(this)
                .attr("style", "height: " + converted + "rem;")
                .addClass(classes);
            });
          }
        }

        function editorWidth() {
          //          if($('.editor-styles-wrapper').length) {
          //            var width = $('.editor-styles-wrapper').width(),
          //              offset = ($('.editor-styles-wrapper').offset().left - $('main').offset().left + 15),
          //              full = $('main').width();
          //            $('.editor-styles-wrapper').attr('style', '--width:' + width + 'px; --offset:' + offset + 'px; --full:' + full + 'px');
          //          }
          //          if($('.editor-styles-wrapper>*.wp-block-cover:first-child').length) {
          //            var height = $('.editor-styles-wrapper>*.wp-block-cover:first-child').outerHeight();
          //            var factHeight = $('.fact-sheet').outerHeight();
          //            $('.fact-sheet').attr('style', '--height:' + height + 'px; --factHeight:' + factHeight + 'px;');
          //          }

          if (
            $(
              ".editor-styles-wrapper > .wp-block-cover.alignfull:first-of-type"
            ).length
          ) {
            $("section.breadcrb").addClass("over");
          }
          if ($(".bg-sidebar").length) {
            var heightHeader = $(
              ".wp-block-cover.alignfull:first-of-type"
            ).outerHeight();
            var sidebarHeight = $(".bg-sidebar").innerHeight();
            var firstEl = $(
              ".editor-styles-wrapper > *:nth-child(2)"
            ).outerHeight();

            $("main").attr(
              "style",
              "--headerHeight: " +
                heightHeader +
                "px; --firstEl: " +
                firstEl +
                "px; --topOffset: " +
                sidebarHeight +
                "px"
            );
          }

          $(".is-style-label-display, .is-style-label-display-w-orange").each(
            function () {
              $(this).attr("style", "--width: " + $(this).text().length);
            }
          );

          $('.wp-block-image figure[class^="align"]').each(function () {
            var figHeight = $(this).height();
            var figWidth = $(this).width();
            $(this)
              .parents(".wp-block-image")
              .attr(
                "style",
                "--figHeight:" +
                  figHeight +
                  "px; --figWidth: -" +
                  figWidth +
                  "px;"
              );
          });
          if ($(".home .home-cta").length) {
            var cta = $(".home-cta").outerHeight();
            $(".home__hero").attr("style", "--ctaHeight: " + cta + "px");
          }
        }

        function draw() {
          var el = document.querySelector("#linepath");
          var myAnimation = new LazyLinePainter(el, {
            ease: "easeInOutExpo",
            strokeWidth: 14.3,
            strokeOpacity: 1,
            strokeColor: "#ffffff",
            strokeCap: "square",
            reverse: true,
          });
          myAnimation.paint();
          myAnimation.on("complete", function () {
            var dot = document.querySelector("#dot");
            $(dot).attr("class", "in");
          });
        }
        spacerREM();
        editorWidth();
        $(window).load(function () {
          $(".editor-styles-wrapper > p:empty").each(function () {
            $(this).remove();
          });

          if (window.location.hash) {
            var videoEl = $(window.location.hash).children("video");

            if ($(window.location.hash).hasClass("is-style-popup-player")) {
              $(window.location.hash + " video")
                .trigger("click")
                .addClass("triggered");
              document.querySelector(window.location.hash + " video").play();
            }
          }

          if (
            !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            ) &&
            $(window).width() > 1024
          ) {
            $.stellar({
              // positionProperty: 'transform',
              hideDistantElements: false,
            });
          }

          $(".preloader").addClass("hidden");

          setTimeout(function () {
            draw();
          }, 1000);

          $("body").addClass("animate");
        });

        if ($(window).width() > 768) {
          fitty(".stat h4", {
            maxSize: 140,
          });
          fitty(".cta-text", {
            minSize: 10,
            maxSize: 16,
          });
          fitty(".stat h5", {
            minSize: 18,
          });
          fitty(".fittext");
        }

        var resizeTimer;

        $(window).on("resize", function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            //            spacerREM()
            $("body").attr(
              "style",
              "--height: " +
                $(".stickyMenu .home__hero__logo").outerHeight() +
                "px;"
            );

            $(".is-style-popup-player video").each(function () {
              var elHeight = $(this).outerHeight(),
                elWidth = $(this).outerWidth(),
                elTop = $(this).offset().top,
                elLeft = $(this).offset().left - window.pageXOffset,
                offsetTop = $(this).offset().top - window.pageYOffset,
                el = $(this);

              $(this)
                .parents(".is-style-popup-player")
                .attr(
                  "style",
                  "--height: " +
                    elHeight +
                    "px; --width:" +
                    elWidth +
                    "px; --top: " +
                    elTop +
                    "px; --left: " +
                    elLeft +
                    "px; --offsetTop: " +
                    offsetTop +
                    "px;"
                );
            });

            editorWidth();
          }, 1000);
        });
      },
    }, // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
        /**
         * Setup your Lazy Line element.
         * see README file for more settings
         */
        //        $(window).load(function () {})
        //        //Hero slider
        $("#heroSlider").slick({
          autoplay: true,
          arrows: false,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: false,
          // infinite: true,
          pauseOnHover: true,
          swipe: true,
          touchMove: false,
          fade: true,
          // speed: 500,
          autoplaySpeed: 10000,
          // useTransform: true,
          // cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
          adaptiveHeight: false,
        });
        // On init event

        $("#heroSlider").on("afterChange", function (event, slick) {
          $(".slick-current.slick-active").find(".h1").addClass("active");
          //  $('.slick-active').find("h2").addClass("active");
          //  $('.slick-active').find(".hspan").addClass("active");
          //  $('.slick-active').find("a").addClass("active");
          //      if ($(window).width() > 767) {
          //        $('#bgvid').get(0).play();
          //      }
        });
        $("#heroSlider").on("beforeChange", function (event, slick) {
          $(".slick-slide").find(".h1").removeClass("active");
          //  $('.slick-active').find("h2").removeClass("active");
          //  $('.slick-active').find(".hspan").removeClass("active");
          //  $('.slick-active').find("a").removeClass("active");
          //      if ($(window).width() > 767) {
          //        $('#bgvid').get(0).play();
          //      }
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
        // init controller

        setTimeout(function () {
          $(".slick-track")
            .first(".slick-slide")
            .find(".h1")
            .addClass("active");
        }, 250);

        var controller = new ScrollMagic.Controller({
          globalSceneOptions: {
            duration: 100,
          },
        });
        new ScrollMagic.Scene({
          triggerElement: ".home__section2 h2",
        })
          .addTo(controller)
          .on("enter", function (e) {
            $(".home__section2").addClass("active");
          });
        new ScrollMagic.Scene({
          triggerElement: ".home__section1 h2",
        })
          .addTo(controller)
          .on("enter", function (e) {
            $(".home__section1").addClass("active");
          });
      },
    }, // About us page, note the change from about-us to about_us.
    page_template_archive_team: {
      init: function () {
        // JavaScript to be fired on the about us page

        $(window).on("load", function () {
          var urlParams = new URLSearchParams(window.location.search); //get all parameters
          var filter = urlParams.get("swpquery"); //extract the foo parameter - this will return NULL if foo isn't a parameter

          if (filter) {
            $("body").addClass("filtered");
            //check if foo parameter is set to anything
            // $(".single-card")
            //   .not("." + filter)
            //   .remove();
          }
        });

        $(".mobile-filter-toggle a").click(function () {
          $(".dropdown").slideToggle(300);
        });

        $(".dropdown a").click(function (e) {
          e.stopPropagation();

          function additiveFilter() {
            $(toggle)
              .text(defaultText)
              .removeClass("filtered")
              .attr("data-toggle", "all");
            $(clear).css("opacity", "0");

            if ($("body").hasClass("filtered-twice")) {
              var existingFilter = $(".filtered").attr("data-toggle");

              console.log(existingFilter);
              console.log("removing " + mode + " filter");

              $(box)
                .not("." + existingFilter)
                .fadeOut(300);
              $("." + existingFilter)
                .fadeIn(300)
                .removeClass(mode);
              $("body")
                .removeClass("filtered-twice")
                .removeClass("by-expertise")
                .removeClass("by-title");
            } else {
              $(box)
                .fadeIn(300)
                .removeClass("by-expertise")
                .removeClass("by-title")
                .removeClass("once");

              $("body")
                .removeClass("filtered-once")
                .removeClass("filtered-twice")
                .removeClass("by-expertise")
                .removeClass("by-title");
            }
          }
          //          $('.clear').trigger('click');
          var dropdown = $(this).parents(".dropdown");
          var toggle = $(this).parents(".dropdown").find(".toggle");
          var defaultText = $(toggle).attr("data-src");
          var clear = $(this).parents(".dropdown").find(".clear");
          var data = $(this).attr("data-toggle");
          var filter = $(".filterable");
          var box = $(".single-team-box");

          var mode = $(this).parents(".dropdown").find(".toggle").attr("title");

          if ($(this).hasClass("clear")) {
            additiveFilter();
          } else {
            if (dropdown.hasClass("open")) {
              dropdown.removeClass("open");
              if ($(this).not(toggle)) {
                if (data == "all") {
                  $(".toggle")
                    .not(toggle)
                    .text($(".toggle").not(toggle).attr("data-src"))
                    .attr("data-toggle", "all")
                    .removeClass("filtered");
                  $(".clear").not(clear).css("opacity", "0");

                  additiveFilter();
                } else {
                  if (
                    $("body").hasClass("filtered-once") &&
                    !$(toggle).hasClass("filtered")
                  ) {
                    $(box)
                      .not(
                        "." +
                          mode +
                          ", ." +
                          data +
                          ', .filterable[style="display: none;"]'
                      )
                      .fadeOut(300)
                      .addClass(mode);
                    $("body").addClass("filtered-twice");
                  } else {
                    $(box)
                      .not("." + data)
                      .addClass(mode)
                      .fadeOut(300);
                    $("." + data)
                      .addClass("once")
                      .delay(350)
                      .fadeIn(300);
                  }

                  $(toggle)
                    .text($(this).text())
                    .attr("data-toggle", data)
                    .addClass("filtered");
                  $(clear).css("opacity", ".75");
                  $("body").addClass("filtered-once").addClass(mode);
                  console.log(mode);
                }
              }
            } else {
              dropdown.addClass("open");
            }
          }

          return false;
        });
        //        $('.dropdown a').click(function (e) {
        //          e.stopPropagation();
        //          var dropdown = $('.dropdown');
        //          var toggle = $('.dropdown > a');
        //          var data = $(this).attr('data-toggle');
        //          var filter = $('.filterable');
        //          var box = $('.single-team-box');
        //          if (dropdown.hasClass('open')) {
        //            dropdown.removeClass('open');
        //            if ($(this).not(toggle)) {
        //              toggle.text($(this).text());
        //              toggle.attr('data-toggle', data);
        //              if (data == 'all') {
        //                $(box).fadeIn(300);
        //              } else {
        //                $(box).fadeOut(300);
        //                $('.' + data).delay(350).fadeIn(300);
        //              }
        //            }
        //          } else {
        //            dropdown.addClass('open');
        //          }
        //          return false;
        //        });
        $("body").click(function (e) {
          var dropdown = $(".dropdown");

          //          e.stopPropagation();
          if (dropdown.hasClass("open")) {
            dropdown.removeClass("open");
          }
        });
      },
    }, // About us page, note the change from about-us to about_us.
    page_template_search_team: {
      init: function () {
        // JavaScript to be fired on the about us page
        $(".dropdown .toggle").click(function (e) {
          e.stopPropagation();
          var dropdown = $(this).parents(".dropdown");
          var toggle = $(this);
          var data = $(this).attr("data-toggle");
          var filter = $(".filterable");
          var box = $(".single-team-box");
          if (dropdown.hasClass("open")) {
            dropdown.removeClass("open");
            if ($(this).not(toggle)) {
              toggle.text($(this).text());
              toggle.attr("data-toggle", data);
              if (data == "all") {
                $(box).fadeIn(300);
              } else {
                $(box).fadeOut(300);
                $("." + data)
                  .delay(350)
                  .fadeIn(300);
              }
            }
          } else {
            dropdown.addClass("open");
          }
          return false;
        });
        //        $('body').click(function (e) {
        //          var dropdown = $('.dropdown');
        //
        //          e.stopPropagation();
        //          if (dropdown.hasClass('open')) {
        //            dropdown.removeClass('open');
        //          }
        //        });
      },
    }, // About us page, note the change from about-us to about_us.
    page_template_impact: {
      init: function () {
        // JavaScript to be fired on the about us page
        $(".cat-item").each(function () {
          var data = $(this).find("a").attr("href");
          var data = data.split("/");
          var anchor = $(this).find("a");
          console.log(data[4]);
          $(anchor).attr("data-toggle", data[4]);
          $(anchor).attr("href", "#");
        });
        $(".dropdown a").click(function (e) {
          e.stopPropagation();
          //          $('.clear').trigger('click');
          var dropdown = $(this).parents(".dropdown");
          var toggle = $(this).parents(".dropdown").find(".toggle");
          var defaultText = $(toggle).attr("data-src");
          var clear = $(this).parents(".dropdown").find(".clear");
          var data = $(this).attr("data-toggle");
          var filter = $(".filterable");
          var box = $(".single-post-box");

          if ($(this).hasClass("clear")) {
            $(box).fadeIn(300);
            $(toggle).text(defaultText);
            $(toggle).attr("data-toggle", "all");
            $(clear).css("opacity", "0");
          } else {
            if (dropdown.hasClass("open")) {
              dropdown.removeClass("open");
              if ($(this).not(toggle)) {
                if (data == "all") {
                  $(".toggle")
                    .not(toggle)
                    .text($(".toggle").not(toggle).attr("data-src"))
                    .attr("data-toggle", "all");
                  $(".clear").not(clear).css("opacity", "0");

                  $(box).fadeIn(300);
                  $(toggle).text(defaultText);
                  $(toggle).attr("data-toggle", "all");
                  $(clear).css("opacity", "0");
                } else {
                  $(".toggle")
                    .not(toggle)
                    .text($(".toggle").not(toggle).attr("data-src"))
                    .attr("data-toggle", "all");
                  $(".clear").not(clear).css("opacity", "0");

                  $(box).fadeOut(300);
                  $("." + data)
                    .delay(350)
                    .fadeIn(300);
                  $(toggle).text($(this).text());
                  $(toggle).attr("data-toggle", data);
                  $(clear).css("opacity", ".75");
                }
              }
            } else {
              dropdown.addClass("open");
            }
          }

          return false;
        });
        //        $('body').click(function (e) {
        //          var dropdown = $('.dropdown');
        //
        //          e.stopPropagation();
        //          if (dropdown.hasClass('open')) {
        //            dropdown.removeClass('open');
        //          }
        //        });
      },
    },
    archive: {
      init: function () {
        // $.urlParam = function (name) {
        //   var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        //     window.location.href
        //   );
        //   return results[1] || 0;
        // };

        $(window).on("load", function () {
          var urlParams = new URLSearchParams(window.location.search); //get all parameters
          var filter = urlParams.get("filter"); //extract the foo parameter - this will return NULL if foo isn't a parameter

          if (filter) {
            $("body").addClass("filtered");
            //check if foo parameter is set to anything
            $(".single-card")
              .not("." + filter)
              .remove();
          }
        });
      },
    },
    single: {
      init: function () {
        // $.urlParam = function (name) {
        //   var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        //     window.location.href
        //   );
        //   return results[1] || 0;
        // };

        // var windowWidth;

        function sidebarInit() {
          var sidebar = $(".fact-sheet .container").parent()[0],
            firstP = $(".editor-styles-wrapper > p:first-of-type"),
            backLink = $("a.mb-0.primary.cyan strong").parent()[0];

          if (
            $(".editor-styles-wrapper > a.mb-0.primary.cyan strong").length <
              1 &&
            $(".bg-sidebar").length
          ) {
            if ($(window).width() < 993) {
              $("body").addClass("mobile-sidebar");
              $(backLink).clone().insertBefore(firstP);
              $(sidebar).clone().insertAfter(firstP);
            }

            // $(firstP).before(backLink).after(sidebar);
          }
        }

        $(window).on("load", function () {
          sidebarInit();
          // windowWidth = $(window).innerWidth();
        });
        var resizeTimer;

        $(window).on("resize", function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            sidebarInit();
          }, 1000);
        });
      },
    },
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");
      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );
      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
